import { render, staticRenderFns } from "./china-map.vue?vue&type=template&id=4d1a6139&scoped=true&"
import script from "./china-map.vue?vue&type=script&lang=js&"
export * from "./china-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a6139",
  null
  
)

export default component.exports